"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconDefaultOrganization = _interopRequireDefault(require("./media/IconDefaultOrganization.png"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LogoImage = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LogoImage, _Component);

  var _super = _createSuper(LogoImage);

  function LogoImage(props) {
    (0, _classCallCheck2.default)(this, LogoImage);
    return _super.call(this, props);
  }

  (0, _createClass2.default)(LogoImage, [{
    key: "render",
    value: function render() {
      var imageSrc = _IconDefaultOrganization.default;

      if (this.props.memberLogoUrl) {
        imageSrc = this.props.memberLogoUrl;
      } else if (this.props.imageBaseUrl) {
        imageSrc = "".concat(this.props.imageBaseUrl, "/u/logo/institution/").concat(this.props.member.id, ".png");
      }

      return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("img", {
        src: imageSrc,
        role: "presentation",
        alt: this.props.member.name + ' Logo',
        onError: function onError(e) {
          if (!e.target.src.endsWith(_IconDefaultOrganization.default)) e.target.src = _IconDefaultOrganization.default;
        }
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        imageBaseUrl: _propTypes.default.string,
        memberLogoUrl: _propTypes.default.string,
        member: _propTypes.default.shape({
          id: _propTypes.default.number.isRequired,
          name: _propTypes.default.string.isRequired
        }).isRequired
      };
    }
  }]);
  return LogoImage;
}(_react.Component);

exports.default = LogoImage;